var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "48px",
    viewBox: "0 0 34 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconfinder_Streamline-93_185113") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Who-We-Are",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-461.000000, -590.000000)",
    fill: "#555659",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_Streamline-93_185113",
    transform: "translate(461.000000, 590.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,48 L5,48 C4.472,48 4.035,47.59 4.002,47.062 L2.002,15.062 C1.985,14.787 2.082,14.516 2.271,14.315 C2.46,14.114 2.724,14 3,14 L31,14 C31.276,14 31.54,14.114 31.729,14.315 C31.918,14.516 32.015,14.787 31.998,15.062 L29.998,47.062 C29.965,47.59 29.528,48 29,48 Z M5.939,46 L28.06,46 L29.935,16 L4.064,16 L5.939,46 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,16 L1,16 C0.448,16 0,15.553 0,15 L0,7 C0,6.447 0.448,6 1,6 L33,6 C33.552,6 34,6.447 34,7 L34,15 C34,15.553 33.552,16 33,16 Z M2,14 L32,14 L32,8 L2,8 L2,14 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.02,8 C31.014,7.999 31.007,8 31,8 L3,8 C2.679,8 2.377,7.846 2.189,7.585 C2.001,7.324 1.95,6.988 2.051,6.684 L4.051,0.684 C4.188,0.275 4.569,0 5,0 L29,0 C29.431,0 29.812,0.275 29.949,0.684 L31.889,6.505 C31.972,6.651 32.02,6.82 32.02,7 C32.02,7.553 31.572,8 31.02,8 Z M4.387,6 L29.613,6 L28.28,2 L5.721,2 L4.387,6 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5,24 L3.5,24 C2.948,24 2.5,23.553 2.5,23 C2.5,22.447 2.948,22 3.5,22 L30.5,22 C31.052,22 31.5,22.447 31.5,23 C31.5,23.553 31.052,24 30.5,24 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.25,
    y: 34,
    width: 25.5,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,30 L14,30 C13.448,30 13,29.553 13,29 C13,28.447 13.448,28 14,28 L20,28 C20.552,28 21,28.447 21,29 C21,29.553 20.552,30 20,30 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.243722d32e84a11b3ecac630abafdd12.svg";
export { ForwardRef as ReactComponent };